export enum UserRole { 
    ADMIN = 'ADMIN',
    MANAGER = 'MANAGER',
    OPERATOR = 'OPERATOR',
    VOJO = 'VOJO'
 }